<template>
  <transition class="tribute-item-transition" type="fade">
    <div class="box tribute-item">
      <div class="media">
        <div class="media-content">
          <div class="columns">
            <div class="column is-two-thirds">
              <p class="title is-5">{{tribute.user}} wrote</p>
              <div class="content">
                <p class="has-whitespace">{{ tribute.comment }}</p>
                <p class="has-text-small is-size-7">{{ dateToStr(tribute.created_at) }}</p>
              </div>
            </div>
            <div class="column is-one-third">
              <div class="level">
                <div v-if="tribute.candle" class="level-item">
                  <div class="tribute-candle sprite-candle sprite-candle1"></div>
                </div>
                <div v-if="tribute.flower" class="level-item">
                  <div class="tribute-flower"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss">
@import "@/assets/vars.scss";

.tribute-item {
  margin-bottom: 2em;

  .has-whitespace {
    white-space: pre-line;
  }

  .title {
    text-transform: capitalize;
  }

  .media-content {
    min-height:170px;
  }
}

.tribute-flower {
  display: block;
  background-image: url('../assets/images/flower.png');
  background-repeat: no-repeat;
  width:81px;
  height:170px;
}

// Candle
.tribute-candle {
    background-image: url('../assets/images/candlesheet.png');
    width: 24px;
    height: 87px;
    background-repeat: no-repeat;
    display: block;
}

.sprite-candle1 {
    background-position: -5px -5px;
}

.sprite-candle2 {
    background-position: -39px -5px;
}

.sprite-candle3 {
    background-position: -73px -5px;
}

.sprite-candle4 {
    background-position: -107px -5px;
}

.sprite-candle5 {
    background-position: -141px -5px;
}

.sprite-candle6 {
    background-position: -175px -5px;
}

.sprite-candle7 {
    background-position: -209px -5px;
}

.sprite-candle {
  animation: candleplay 0.8s steps(6) infinite;
}

@keyframes candleplay {
   100% { background-position: -209px -5px; }
}
</style>

<script>
import moment from 'moment';

export default {
  props: {
    tribute: {
      type: Object,
      required: true,
    },
  },
  methods: {
    dateToStr(dt) {
      return moment.unix(dt.seconds).format('MM/DD/YYYY');
    },
  },
};
</script>
